var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualIdentitydesign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-d5b49c40-72c1-4138-a9dd-7a64d2aa7151",
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.8,
    height: 42.5,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 83.8 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-6b458e47-a422-4d15-8dac-ca2fe6e80b33{fill:url(#uuid-854770fe-158f-491a-b11d-ac85eab0c7bc);}.uuid-58c52c5c-403b-49a8-be33-2ce3f8c2ba43{fill:url(#uuid-f5994cb9-d203-4b09-8156-777ea445a280);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f5994cb9-d203-4b09-8156-777ea445a280",
    x1: 0,
    y1: 21.2,
    x2: 83.8,
    y2: 21.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab73d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-854770fe-158f-491a-b11d-ac85eab0c7bc",
    x1: 31.4,
    y1: 21.3,
    x2: 52.5,
    y2: 21.3,
    xlinkHref: "#uuid-f5994cb9-d203-4b09-8156-777ea445a280"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-6cf4e95c-8c34-4021-9fc9-78755f64e057"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-58c52c5c-403b-49a8-be33-2ce3f8c2ba43",
    d: "M37.8.1c16.5-1.1,32.9,5.3,43.8,17.8.6.7,2.5,2.8,2.2,3.6s-5,6-6.2,7c-20.1,18.6-51.6,18.5-71.6-.2C4.9,27.4.2,22.5,0,21.5s5.9-7.2,7.1-8.3C15.3,5.9,26.9.9,37.8.1ZM40.4,2.5c-15.1,1.2-22.7,19.1-12.9,30.8,8.4,10.1,24.6,8.5,30.9-3,7.2-13.1-3.1-29-17.9-27.8ZM29.2,4.1C19.1,6.8,9.2,12.8,3,21.3c4.7,6.1,11.3,11.2,18.3,14.3,1.9.8,5.3,2.3,7.3,2.6s.4,0,.4-.1c-11.1-8.5-10.9-25.6.2-34ZM54.9,38.2c6.1-1.5,12.3-4.5,17.3-8.3,1.3-1,8.6-7.5,8.7-8.6s-4-4.8-4.8-5.5c-6-5.5-13.4-9.4-21.1-11.6l4.4,4.8c6.6,9.4,4.5,22.2-4.4,29.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6b458e47-a422-4d15-8dac-ca2fe6e80b33",
    d: "M39.9,10.7c15.1-2.2,17.2,19.7,3.3,21.3-14.1,1.6-16.1-19.4-3.3-21.3ZM40.7,13.1c-9.9,1.3-8.8,16.6,1.4,16.5,11.2-.1,10.5-18.1-1.4-16.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualIdentitydesign);
export default __webpack_public_path__ + "static/media/Visual Identity design.ee5fa5a8ef44b3b66558c6fea2532a22.svg";
export { ForwardRef as ReactComponent };